// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const advisorBriefExportApiAdvisorRunsRunIdBriefPdfGetParamsKindDefault = `seller`;
export const AdvisorBriefExportApiAdvisorRunsRunIdBriefPdfGetParams = zod.object({
  "kind": zod.enum(['seller', 'client']).default(advisorBriefExportApiAdvisorRunsRunIdBriefPdfGetParamsKindDefault)
})

export type AdvisorBriefExportApiAdvisorRunsRunIdBriefPdfGetParams = zod.input<typeof AdvisorBriefExportApiAdvisorRunsRunIdBriefPdfGetParams>;
export type AdvisorBriefExportApiAdvisorRunsRunIdBriefPdfGetParamsOutput = zod.output<typeof AdvisorBriefExportApiAdvisorRunsRunIdBriefPdfGetParams>;
